
















import TitleH2 from "@/components/common/TitleH2.vue";

import CertificateSlider from "./blocks/CertificateSlider.vue";
import ReviewsSlider from "./blocks/ReviewsSlider.vue";

export default {
  name: "Reviews",
  components: {
    ReviewsSlider,
    CertificateSlider,
    TitleH2,
  },
  props: {
    reviews: { type: Array, default: () => [] },
    certificates: { type: Array, default: () => [] },
  },
};
